/**
 * Auth Event Bus
 * Allows non-React code (httpClient interceptor) to signal auth events
 * without hard page reloads. React components listen and use navigate().
 */

export type AuthEventReason = 'refresh_failed' | 'token_invalid' | 'manual';

export interface AuthEventDetail {
  reason: AuthEventReason;
}

type AuthEventHandler = (detail: AuthEventDetail) => void;

class AuthEventBus {
  private listeners = new Map<string, Set<AuthEventHandler>>();

  on(event: string, handler: AuthEventHandler): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(handler);
    return () => {
      this.listeners.get(event)?.delete(handler);
    };
  }

  emit(event: string, detail: AuthEventDetail): void {
    this.listeners.get(event)?.forEach((h) => {
      try {
        h(detail);
      } catch (err) {
        console.error('[AuthEventBus] Handler error:', err);
      }
    });
  }
}

export const authEvents = new AuthEventBus();
